import { Box, Typography } from "@mui/material";
import React from "react";
import PostBidDescription from "./PostBidDescription";
import UploadPhoto from "./UploadPhoto";

function PostBidUploadImages({ bidData, assistantDraft }) {
  const [next, setNext] = React.useState(false);
  const setImages = (e, size) => {
    let files = [];
    console.log(size);
    if (size !== 0) {
      for (let i = 0; i < e[0].length; i++) files.push(e[0][i]);
      console.log(files);
      bidData.bidImages = files;
      bidData.size = size;
      setNext(true);
    } else {
      bidData.bidImages = e;
      bidData.size = size;
      setNext(true);
    }
  };

  return (
    <Box className="bidit-postbid-step">
      {!next && (
        <>
          <Box
            className="bidit-form-intro bidit-upload-intro"
            sx={{
              width: { xs: "92%", sm: "85%", md: "70%" },
              maxWidth: "600px",
              mx: "auto",
              mt: 2.5,
              mb: 0,
              px: 2,
            }}
          >
            <Box className="bidit-form-intro-badge">
              <span className="bidit-form-intro-spark">✦</span>
              שלב 3
            </Box>
            <Typography
              variant="h6"
              className="bidit-form-title"
              sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
            >
              יש תמונה או סרטון? זה יכול לעזור
            </Typography>
            <Typography
              className="bidit-form-subtitle"
              sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
            >
              המחשה טובה עוזרת לבעלי המקצוע להבין מהר יותר את העבודה. אפשר גם לדלג.
            </Typography>
          </Box>
          <UploadPhoto setImages={setImages} />
        </>
      )}
      {next && <PostBidDescription bidData={bidData} assistantDraft={assistantDraft} />}
    </Box>
  );
}

export default PostBidUploadImages;
